import { API } from './index';

export function getProfileInfo(project: string | null): Promise<any> {
    return API.get(`/user/get-profile-info?project=${project || ''}`);
}

export function setUserProfileInfo(firstName: string, lastName: string): Promise<any> {
    return API.post('/user/set-profile-info', { firstName, lastName });
}

export function getReceiptLink(privatePaymentId: string): Promise<any> {
    return API.get(`/user/get-receipt-link?privatePaymentId=${privatePaymentId}`);
}